import { LIMPAR_CIDADE_SELECIONADA } from '../types';

export default function limparCidadeSelecionada () {
  return {
    type: LIMPAR_CIDADE_SELECIONADA
  }
}
